import React from 'react';
import { LoadingOverlay, LoadingOverlayProps } from '@mantine/core';

export function ELoadingOverlay({ ...props }: LoadingOverlayProps) {
    return (
        <LoadingOverlay
            visible={true}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 2 }}
            {...props}
        />
    )
}
